import React, { useEffect } from "react";
import { initializeApp, getApps } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { firebaseConfig, VAPID_KEY } from "./firebaseConfig";
import { useApiMutation } from "hooks/useApi/useApiHooks";
import { notification } from "antd";
import { useNavigate } from "react-router-dom";

const FirebaseApp = () => {
    const storageToken = !!localStorage.getItem("token");
    const { mutate } = useApiMutation("/fcm-token", "post", {}, true);
    const navigate = useNavigate();

    useEffect(() => {
        const firebaseInitialize = async () => {
            const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);
            const messaging = getMessaging(app);

            try {
                const currentToken = await getToken(messaging, {
                    vapidKey: VAPID_KEY,
                });
                
                if (currentToken && storageToken) {
                    mutate({ fcmToken: currentToken });
                } else {
                    console.warn("No registration token available.");
                }
            } catch (error) {
                console.error("An error occurred while retrieving token:", error);
            }

            onMessage(messaging, (payload) => {
                try {
                    const parsed = JSON.parse(payload?.data?.payload || '{}');
                    const type = parsed?.type;

                    if (type === "studentCreated") {
                        notification.open({
                            message: "Yangi o'quvchi qo'shildi!",
                            description: `${parsed?.studentCreated.newStudentFullName || ''} qo'shildi.`,
                            placement: "topRight",
                            duration: 5,
                            style: {
                                width: 300,
                                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                                borderRadius: 8,
                            },
                            onClick: () => {
                                navigate("/students");
                            },
                        });
                    }else if(type === "employeeCreated") {
                        notification.open({
                            message: "Yangi xodim qo'shildi!",
                            description: `${parsed.employeeCreated.createdBy} tomonidan ${parsed?.employeeCreated.newEmployeFullName || ''} qo'shildi.`,
                            placement: "topRight",
                            duration: 5,
                            style: {
                                width: 300,
                                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                                borderRadius: 8,
                            },
                            onClick: () => {
                                navigate("/employees");
                            },
                        });
                    } else {
                        // console.log("📩 Other notification type:", type);
                    }
                } catch (e) {
                    console.error("❌ Failed to parse message params:", e);
                }
            });
        };

        firebaseInitialize();
    }, []);

    return null;
};

export default FirebaseApp;

